var AbstractTracker = require("app/Analytics/AbstractTracker"),
    config          = require("app/config"),
    deepEqual       = require("fast-deep-equal"),
    get             = require("object-path").get,
    kind            = require("enyo/kind"),
    quickMacroize   = require("enyo/macroize").quickMacroize;

module.exports = kind(/** @lends  app.Analytics.Hotjar.prototype */ {

    /**
     * @private
     */
    name: "app.Analytics.Hotjar",

    /**
     * @private
     */
    kind: AbstractTracker,

    /**
     * Whether the tracker is form an IAB Vendor.
     */
    isNonIABVendor: true,

    /**
     * Cached copy of consent data, used to detect consent changes.
     *
     * @private
     */
    consent: null,

    // Vendor Transparency and Consent
    // ----------------

    /**
     * Respond to changes in consent.
     *
     * @private
     */
    onNonIABConsentDataChange: function() {
        var $privacyService = this.app.$.privacyService,
            consent         = $privacyService.get("nonIABConsentData"),
            consentChanged  = !deepEqual(this.consent, consent);

        // Update consent state
        if (consentChanged) {
            this.consent = consent;
        }
        else {
            return;
        }

        // We are not responsible for loading ourselves
        if (get(config, "hotjar.loader", null) !== "self") {
            return;
        }

        // We aren't ready yet, but are allowed to load.
        if (!this.isReady && this.hasLoadConsent()) {
            this.load();
        }

        // We are ready, but consent has just been revoked.
        else if (this.isReady && !this.hasLoadConsent()) {
            this.app.$.router.reload();
        }
    },

    // Loading
    // ----------------

    /**
     * @returns  {boolean}  Whether we have consent to load the Hotjar
     * @private
     */
    hasLoadConsent: function() {
        var $privacyService   = this.app.$.privacyService,
            nonIABConsentData = $privacyService.get("nonIABConsentData");

        // Bypass parameter set
        if ($privacyService.shouldBypassConsent()) {
            return true;
        }

        // Consent for 'advertisement' purpose required
        else {
            return nonIABConsentData
                && nonIABConsentData.accepted
                && Array.isArray(nonIABConsentData.accepted)
                && nonIABConsentData.accepted.includes("functional")
                && nonIABConsentData.accepted.includes("analytics");
        }
    },

    /**
     * @return {string|null} The loader
     * @public
     */
    getLoader: function() {
        return get(config, "hotjar.loader", null);
    },

    /**
     * @private
     */
    load: function() {
        var url,
            script;

        // Hotjar not enabled
        if (!get(config, "hotjar.enabled", false)
            || get(config, "hotjar.loader", null) !== "self"
            || !get(config, "hotjar.hjid", false)
            || !get(config, "hotjar.hjsv", false)) {
            return;
        }

        // Bail if already loaded
        if (this.isReady) {
            return;
        }

        // Prepare tracker function
        window.hj          = window.hj || function() {
            (window.hj.q = window.hj.q || []).push(arguments);
        };
        window._hjSettings = {
            hjid: get(config, "hotjar.hjid", null),
            hjsv: get(config, "hotjar.hjsv", null)
        };

        // Build url
        url = new URL(quickMacroize("https://static.hotjar.com/c/hotjar-{$hjid}.js", {
            hjid: window._hjSettings.hjid
        }));
        url.searchParams.set("sv", window._hjSettings.hjsv);

        // Load script
        script         = document.createElement("script");
        script.async   = true;
        script.src     = url.toString();
        script.onload  = this.onLoad;
        script.onerror = this.onLoadError;
        document.head.appendChild(script);
    },

    /**
     * @returns  {boolean}  `true` when ready, `false` otherwise.
     * @private
     */
    verifyReadiness: function() {
        return typeof hj !== "undefined" ? true : false;
    },

    /**
     * @private
     */
    onReady: kind.inherit(function(sup) {
        return function() {
            // Consent has been revoked while we were getting ready
            if (get(config, "hotjar.loader", null) === "self"
                && !this.hasLoadConsent()) {
                this.app.$.router.reload();

                return;
            }

            sup.apply(this, arguments);
        };
    })

});
